import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { getScaledValueByDevice, Device } from 'DeviceUtils';

let baseStyles = {
    carousel: {
        backgroundColor: Theme.primaryBackgroundColor,
        marginVertical: Device.isWeb ? 0 : getScaledValueByDevice(12),
        flex: 1,
        overflow: 'hidden'
    },
    titlesContainer: {
        flex: 1,
        justifyContent: 'flex-end',
        marginHorizontal: getScaledValueByDevice(10),
        marginVertical: getScaledValueByDevice(35)
    },
    titlesContainerTitle: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    title: {
        fontFamily: Theme.ultraFont,
        fontSize: getScaledValueByDevice(27),
        color: Theme.primaryTextColor,
        maxWidth: '90%'
    },
    subTitle: {
        fontFamily: Theme.regularFont,
        fontSize: getScaledValueByDevice(17),
        color: Theme.primaryTextColor
    },
    paginationContainer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        paddingHorizontal: getScaledValueByDevice(20),
        paddingVertical: getScaledValueByDevice(24)
    },
    paginationDotContainer: {
        marginHorizontal: getScaledValueByDevice(3.5)
    },
    linearGradient: {
        position: 'absolute',
        left: 0,
        width: '100%',
        bottom: 0,
        top: 0
    },
    activityIndicator: {
        flex: 1
    },
    leftArrow: {
        position: 'absolute',
        left: -32,
        height: '100%',
        justifyContent: 'center'
    },
    rightArrow: {
        position: 'absolute',
        right: -32,
        height: '100%',
        justifyContent: 'center'
    },
    imageContainer: {
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        width: '65%',
        height: '100%'
    }
};

if (Device.isPhone) {
    baseStyles = {
        ...baseStyles,
        imageContainer: {
            ...baseStyles.imageContainer,
            width: '100%'
        }
    };
}

if (Device.isWeb) {
    baseStyles = {
        ...baseStyles,
        carousel: {
            ...baseStyles.carousel,
            overflowX: 'hidden'
        },
        title: {
            ...baseStyles.title,
            fontSize: 40
        },
        subTitle: {
            ...baseStyles.subTitle,
            fontSize: 20,
            color: '#EBEBEB'
        },
        titlesContainer: {
            ...baseStyles.titlesContainer,
            marginLeft: 20,
            marginBottom: 50
        },
        imageBackground: {
            position: 'absolute',
            width: '100%',
            bottom: 0,
            top: 0
        }
    };
}

if (Device.isTablet) {
    baseStyles = {
        ...baseStyles,
        linearGradient: {
            ...baseStyles.linearGradient,
            top: undefined,
            height: '50%'
        },
        imageBackground: {
            position: 'absolute',
            width: '100%',
            bottom: 0,
            top: 0
        }
    };
}

export default StyleSheet.create(baseStyles);
